export default __webpack_public_path__ + "static/media/iris-black.dece0929.svg";